/**
 * Multi-Column Product Categories - Make Cards Clickable
 * Makes the entire card clickable, navigating to the collection URL
 * Hidden button is used to extract the URL
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all multi-column cards
  const multiColumnCards = document.querySelectorAll('.multi-column .card');
  
  multiColumnCards.forEach(function(card) {
    // Find the hidden button link within this card
    const buttonLink = card.querySelector('.card__button');
    
    if (buttonLink && buttonLink.href) {
      const targetUrl = buttonLink.href;
      
      // Make the entire card clickable
      card.addEventListener('click', function(e) {
        // Prevent default if clicking on an actual link
        if (e.target.tagName !== 'A') {
          window.location.href = targetUrl;
        }
      });
      
      // Add cursor pointer style
      card.style.cursor = 'pointer';
    }
  });
});